import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.URL,
  GRAPHQL_URL: `${API.GRAPHQL_URL}`,
  createNewFile (payload) {
    const upload = new FormData()
    upload.append('title', payload.title)
    upload.append('path', payload.path)
    upload.append('effective_date', payload.effective_date)
    upload.append('user_id', payload.user_id)
    upload.append('location_id', payload.location_id)
    upload.append('folder_locations_id', payload.folder_locations_id)
    upload.append('is_file_admin', payload.is_file_admin)
    upload.append('organization_id', payload.organization_id)
    upload.append('folder_id', payload.folder_id)
    upload.append('folder_root_id', payload.folder_root_id)

    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}files/`, upload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  createMassiveNewFile (payload) {
    const upload = new FormData()
    upload.append('title', payload.title)
    upload.append('path', payload.path)
    upload.append('effective_date', payload.effective_date)
    upload.append('user_id', payload.user_id)
    upload.append('location_id', payload.location_id)
    upload.append('folder_locations_id', payload.folder_locations_id)
    upload.append('is_file_admin', payload.is_file_admin)
    upload.append('organization_id', payload.organization_id)
    upload.append('folder_id', payload.folder_id)
    upload.append('folder_root_id', payload.folder_root_id)
    upload.append('filesLocations', payload.filesLocations)
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}massiveFiles/`, upload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  updateNewFile (payload) {
    const upload = new FormData()
    upload.append('id', payload.id)
    upload.append('title', payload.title)
    upload.append('path', payload.path)
    upload.append('effective_date', payload.effective_date)
    upload.append('user_id', payload.user_id)
    upload.append('location_id', payload.location_id)
    upload.append('folder_locations_id', payload.folder_locations_id)
    upload.append('is_file_admin', payload.is_file_admin)
    upload.append('organization_id', payload.organization_id)
    upload.append('folder_id', payload.folder_id)
    upload.append('folder_root_id', payload.folder_root_id)
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}file/${payload.id}`, upload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  updateNewFileResources (payload) {
    const upload = new FormData()
    upload.append('id', payload.id)
    upload.append('title', payload.title)
    upload.append('path', payload.path)
    upload.append('effective_date', payload.effective_date)
    upload.append('user_id', payload.user_id)
    upload.append('location_id', payload.location_id)
    upload.append('folder_locations_id', payload.folder_locations_id)
    upload.append('is_file_admin', payload.is_file_admin)
    upload.append('organization_id', payload.organization_id)
    upload.append('folder_id', payload.folder_id)
    upload.append('folder_root_id', payload.folder_root_id)

    if (payload.update_all_locations === true) upload.append('update_all_locations', '1')

    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}updateFile/${payload.id}`, upload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  all () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}files/all`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  byFolder (id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}filesByFolder/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  delete (id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}file/${id}`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  getFrachises () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}getFrachises`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  getLocations () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}getLocations`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  getRoleUsers () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}getRoleUsers`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fileById (id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}fileById/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  showById (id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}showById/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  saveSignatureResource (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}saveSignatureResource/${payload.file_id}`, payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  saveFileName (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}saveFileName/${payload.file_id}`, payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  approveDocument (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}approveDocument/${payload.file_id}`, payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  documentComments (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}documentComments/${payload.file_id}`, payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fileLogByFolder (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}fileLogByFolder/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  }
}
